import React, { useState } from 'react';
import PropTypes from 'prop-types';
import i18n from 'micro-i18n';
import { scaleValueToPercent } from 'utils';
import SpectrumResultColumns from 'components/results/SpectrumResultColumns';
import { IconDownCaret, IconUpCaret } from 'components/icons/Icons';

//FIXME: SOF-617 requires the following imports to be moved to components/widget-components.scss
// due to lazy loading of the widget inside an iframe. Keeping this here for potential fix down the road.
// import 'components/results/SpectrumResultRow.scss';

const SpectrumResultRow = ({ row, columns }) => {
  const { text, options, average } = row;

  const [answeredOptionIndex, setAnsweredOptionIndex] = useState(0);

  const columnValues = columns ? columns.map((column) => {
    const { value } = column;
    return value;
  }) : [];

  const minPercentVal = Math.min(...columnValues);
  const maxPercentVal = Math.max(...columnValues);
  const averageRating = scaleValueToPercent(minPercentVal, maxPercentVal, average);

  const answeredOption = options && options.find((option, index) => {
    const { answered } = option;
    answered && setAnsweredOptionIndex(index);
    return answered;
  });

  return (
    <div className="csw-r-spect-row outline" tabIndex="0"
         aria-label={answeredOption ? i18n.t('RESULT_ANSWERED_SPEC_LBL', {
           percent: answeredOption.percent, text: answeredOption.text, averageRating
         }) : ''}>
      <div className="csw-r-spect-row-text"
           role="heading"
           aria-level="2">{text}</div>

      <div className="csw-r-spect-answers">

        <div className="csw-r-spect-user-answers">
          {options && options.map((option, index) => {
            const { answered } = option;

            return (
              <div className="csw-r-spect-row-user-answer"
                   key={`csw-r-spect-o-${index}`}>
                {answered && <div className="csw-r-spect-row-user-answered">
                  <div className="csw-r-spect-row-user-answered-lbl">
                    {i18n.t('RATING_YOUR_RATING')}
                  </div>
                  <IconDownCaret title={i18n.t('RATING_YOUR_RATING')} />
                </div>}
              </div>
            );
          })}
        </div>

        {columns && <SpectrumResultColumns columns={columns}
                                           columnValues={columnValues}
                                           answeredIndex={answeredOptionIndex} />}

        <div className="csw-r-spect-row-avg-rating-wrapper">
          <div className="csw-r-spect-row-avg-rating"
               style={{ right: `${averageRating}%` }}>
            <IconUpCaret title={i18n.t('RATING_AVERAGE')} />
            <div className="csw-r-spect-row-avg-rating-lbl">
              {i18n.t('RATING_AVERAGE')}
            </div>
          </div>
        </div>

      </div>

    </div>
  );
};

SpectrumResultRow.propTypes /* remove-proptypes */ = {
  row: PropTypes.object.isRequired,
  columns: PropTypes.array.isRequired
};

export default SpectrumResultRow;
